import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { offer, shoe8 } from "../../../assets/images";
import { Button, ReviewCard, ServiceCard } from "../components";

import { reviews, services } from "../../../app/constants";
import { arrowRight } from "../../../assets/icons";
import { ProductCard } from "../../product/ProductsList";
import {
  fetchPopularProductsAsync,
  selectPopularProducts,
} from "../extra slices/PopularProductsSlice";
import { Link } from "react-router-dom";

const CustomerReviews = () => {
  return (
    <section className="max-container">
      <h3 className="font-palanquin text-center text-4xl font-bold">
        What Our
        <span className="text-coral-red"> Customers </span>
        Say?
      </h3>
      <p className="m-auto mt-4 max-w-lg  text-center info-text">
        Hear genuine stories from our satisfied customers about their
        exceptional experiences with us.
      </p>

      <div className="mt-24 flex flex-1 justify-evenly items-center max-lg:flex-col gap-14">
        {reviews.map((review, index) => (
          <ReviewCard
            key={index}
            imgURL={review.imgURL}
            customerName={review.customerName}
            rating={review.rating}
            feedback={review.feedback}
          />
        ))}
      </div>
    </section>
  );
};

const PopularProducts = () => {
  const dispatch = useDispatch();
  const popularProducts = useSelector(selectPopularProducts)?.products;
  useEffect(() => {
    if (!popularProducts) {
      const filter = { _limit: 4, sort: "rating", order: "desc" };
      dispatch(fetchPopularProductsAsync(filter));
    }
  }, [dispatch, popularProducts]);
  return (
    <section id="products" className="max-container max-sm:mt-12">
      <div className="flex flex-col justify-start gap-5">
        <h2 className="text-4xl font-palanquin font-bold">
          Our <span className="text-coral-red"> Popular </span> Products
        </h2>
        <p className="lg:max-w-lg mt-2 font-montserrat text-slate-gray">
          Experience top-notch quality and style with our sought-after
          selections. Discover a world of comfort, design, and value
        </p>
      </div>

      <div className="mt-16 grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 sm:gap-6 gap-16">
        {popularProducts
          ? popularProducts.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))
          : ""}
      </div>
    </section>
  );
};

const Services = () => {
  return (
    <section className="max-container flex justify-center flex-wrap gap-9">
      {services.map((service) => (
        <ServiceCard key={service.label} {...service} />
      ))}
    </section>
  );
};

const SpecialOffer = () => {
  return (
    <section className="flex justify-between items-center max-xl:flex-col-reverse gap-10 max-container">
      <div className="flex-1">
        <img
          src={offer}
          alt="Shoe Promotion"
          width={773}
          height={687}
          className="object-contain w-full"
        />
      </div>
      <div className="flex flex-1 flex-col">
        <h2 className="text-4xl font-palanquin font-bold">
          <span className="text-coral-red">Special </span>
          Offer
        </h2>
        <p className="mt-4 info-text">
          Embark on a shopping journey that redefines your experience with
          unbeatable deals. From premier selections to incredible savings, we
          offer unparalleled value that sets us apart.
        </p>
        <p className="mt-6 info-text">
          Navigate a realm of possibilities designed to fulfill your unique
          desires, surpassing the loftiest expectations. Your journey with us is
          nothing short of exceptional.
        </p>
        <div className="mt-11 flex flex-wrap gap-4">
          <Button label="Shop now" iconURL={arrowRight}>
            ShopNow
          </Button>
          <Button
            label="Learn more"
            backgroundColor="bg-white"
            borderColor="border-slate-gray"
            textColor="text-slate-gray"
          />
        </div>
      </div>
    </section>
  );
};

const Subscribe = () => {
  return (
    <section
      id="contact-us"
      className="max-container flex justify-center items-center flex-col gap-10 h-[50dvh]"
    >
      <h3 className="text-4xl leading-[68px]  font-palanquin font-bold">
        Interesting enough to meet your
        <span className="text-coral-red"> ugly </span> developer?
      </h3>

      <div className="flex max-sm:justify-end items-center max-sm:w-full mt-4">
        <Link to="/contact">
          <Button label="Contact" fullWidth />
        </Link>
      </div>
    </section>
  );
};

const SuperQuality = () => {
  return (
    <section
      id="about-us"
      className="flex justify-between items-center max-lg:flex-col gap-10 w-full max-container"
    >
      <div className="flex flex-1 flex-col">
        <h2 className="font-palanquin capitalize text-4xl lg:max-w-lg font-bold">
          We Provide You
          <span className="text-coral-red"> Super </span>
          <span className="text-coral-red">Quality </span> Products
        </h2>
        <p className="mt-4 lg:max-w-lg info-text">
          Ensuring premium comfort and style, our meticulously crafted footwear
          is designed to elevate your experience, providing you with unmatched
          quality, innovation, and a touch of elegance.
        </p>
        <p className="mt-6 lg:max-w-lg info-text">
          Our dedication to detail and excellence ensures your satisfaction
        </p>
        <div className="mt-11">
          <Button label="View details" />
        </div>
      </div>

      <div className="flex-1 flex justify-center items-center">
        <img
          src={shoe8}
          alt="product detail"
          width={570}
          height={522}
          className="object-contain"
        />
      </div>
    </section>
  );
};

export {
  CustomerReviews,
  PopularProducts,
  Services,
  SpecialOffer,
  Subscribe,
  SuperQuality,
};
